import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-thanks-egresado',
  templateUrl: './thanks-egresado.component.html',
  styleUrls: ['./thanks-egresado.component.scss']
})
export class ThanksEgresadoComponent implements OnInit {

  constructor(private route: ActivatedRoute) {
  
  }
  ngOnInit(): void {
  }

}
